export { default } from "./MiniRTE";
